module.exports = "pegasus_template/assets/custom-1-google.png";